import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-header',
    imports: [],
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.css'
})
export class PageHeaderComponent implements OnInit {
  @Input() pageName: string = '';
  @Input() fromPage: string = '';
  pageHeading: string = '';

  ngOnInit(): void {
    this.pageHeading = this.getPageHeading();
  }

  getPageHeading() {
    let pageType = 'Create ';
    if (this.pageName?.includes('view'))
      pageType = 'View ';
    if (this.pageName?.includes('edit'))
      pageType = 'Edit ';
    return (this.fromPage ? (pageType + this.fromPage) : this.pageName);
  }
}
